import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

import { Col, Row } from "stories/layout"

import { BreadcrumbsDynamic } from 'stories/components';
import IncomeReportSummary from "views/app/IncomeReportSummary/IncomeReportSummary"

const IncomeReports = (props) => {
  const { t } = useTranslation();

  //Export button from IncomeReportSummary
  const [exportButton, setExportButton] = useState(null);

  const getCrumbLinks = () => {
    const tail = {
      name: t("income_report_title", "Tuottoraportti"),
      url: "/dashboard/reports/profit-report",
    };
    if (props.location?.state?.crumbLinks?.length) {
      return [...props.location.state.crumbLinks, tail];
    }
    return [
      { name: t("Etusivu"), url: "/dashboard/" },
      { name: t("Raportit"), url: "/dashboard/reports" },
      tail,
    ];
  };

  
  return (
    <>
    <Row className="d-flex  flex-wrap  ">
    <Col>
      <BreadcrumbsDynamic links={getCrumbLinks()} />
    </Col>
    <Col md="6" xs="12" className="d-flex flex-column justify-content-end  mr-xs-auto align-self-end mb-3 " style={{minWidth: "50px"}}>
      <div className="ml-auto">
         {exportButton}
      </div>
    </Col>
    </Row>
    <IncomeReportSummary setExportButton={setExportButton} / > 
{/*
    <Row>
        <Col className="mb-3">
          <img src={graph01} />
        </Col>
        <Col className="mb-3">
          <img src={graph02} />
        </Col>
  </Row>*/}
    </>
  );
}

export default IncomeReports;